module.exports = __webpack_public_path__ + "img/矩形 150@3x.4a2409c5.png";